import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: '01',
  title: 'Lista de compras SOS',
  desc: 'Menos de $3.000 ARS. Todo lo que necesitás para arrancar el protocolo de 72 horas sin dar vueltas por el súper. Ingredientes reales disponibles en cualquier dietética o supermercado argentino.'
}, {
  num: '02',
  title: 'Guía de suplementación con precios ARS actualizados',
  desc: 'Los suplementos que realmente funcionan para hinchazón, ansiedad y energía. Con marcas disponibles en Argentina, precios actualizados y dónde comprarlos (farmacias + tiendas online).'
}, {
  num: '03',
  title: 'Plan de 21 días integrado',
  desc: 'Los 3 sistemas juntos en un calendario día por día. Sabés exactamente qué hacer cada mañana y cada noche durante 3 semanas completas. Sin pensar. Sin improvisar.'
}];
export function Bonuses() {
  return <section className="py-20 bg-brand-card border-y border-brand-border" data-id="element-21">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-22">
        <FadeIn className="text-center mb-16" data-id="element-23">
          <div className="inline-flex items-center justify-center p-4 bg-brand-cream rounded-full mb-6" data-id="element-24">
            <Gift className="w-10 h-10 text-brand-terracotta" data-id="element-25" />
          </div>
          <h2 className="text-4xl font-bold mb-4" data-id="element-26">🎁 BONOS EXCLUSIVOS</h2>
          <p className="text-xl text-brand-terracotta font-bold uppercase tracking-wider" data-id="element-27">
            Solo en el Megapack Premium
          </p>
        </FadeIn>

        <div className="space-y-6" data-id="element-28">
          {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-29">
              <div className="bg-brand-cream border border-brand-border hover:border-brand-accent transition-colors p-6 rounded-2xl" data-id="element-30">
                <div className="flex items-center gap-3 mb-4" data-id="element-31">
                  <span className="text-sm font-bold text-white bg-brand-verifiedGreen px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-32">
                    BONO {bonus.num}
                  </span>
                  <h3 className="text-xl font-bold text-brand-dark leading-tight" data-id="element-33">
                    {bonus.title}
                  </h3>
                </div>

                <p className="text-brand-muted leading-relaxed" data-id="element-34">{bonus.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}